'use client';
import { jsx } from 'react/jsx-runtime';
import { mergeProps } from '@zag-js/react';
import { forwardRef } from 'react';
import { createSplitProps } from '../create-split-props.mjs';
import { ark } from '../factory.mjs';
import { splitRenderStrategyProps, RenderStrategyProvider } from '../render-strategy.mjs';
import { TabsProvider } from './tabs-context.mjs';
import { useTabs } from './use-tabs.mjs';

const TabsRoot = forwardRef((props, ref) => {
  const [renderStrategyProps, tabsProps] = splitRenderStrategyProps(props);
  const [useTabsProps, localprops] = createSplitProps()(tabsProps, [
    "activationMode",
    "defaultValue",
    "dir",
    "getRootNode",
    "id",
    "ids",
    "loop",
    "onFocusChange",
    "onValueChange",
    "orientation",
    "translations",
    "value"
  ]);
  const api = useTabs(useTabsProps);
  const mergedProps = mergeProps(api.rootProps, localprops);
  return /* @__PURE__ */ jsx(TabsProvider, { value: api, children: /* @__PURE__ */ jsx(RenderStrategyProvider, { value: renderStrategyProps, children: /* @__PURE__ */ jsx(ark.div, { ...mergedProps, ref }) }) });
});
TabsRoot.displayName = "TabsRoot";

export { TabsRoot };
